import React from "react";
import Button from "./Button";

const ViewDocument = ({
  description,
  documentUrl,
  buttonText = "View Document",
  className = "",
}) => {
  const handleClick = () => {
    if (documentUrl) {
      window.open(documentUrl, "_blank");
    }
  };

  return (
    <div
      className={`p-7 bg-[#FEFBF6] rounded-[10px] border-2 border-black flex flex-col items-center justify-center ${className}`}
    >
      <p className="text-black leading-loose text-base font-medium mb-5 text-center">
        {description}
      </p>
      <Button
        title={buttonText}
        className="!min-w-min !px-5"
        onClick={handleClick}
      />
    </div>
  );
};

export default ViewDocument;
